import React, { FC } from 'react'
import { OutcomesView } from './OutcomesView'
import { useGetSubstantiatedTypeMapping } from './OutcomesApi'
import './outcomes.scss'
import { Spinner } from '../Shared/Spinner'
import { UnexpectedError } from '../Shared/Error'
import { DefaultPage } from '@tnwinc/navex-react'

interface IProps {
  toggles: string[]
}

export const OutcomesRoute:FC<IProps> = (props) => {
  
  const [{ mappings, options, loading, status, errors }] = useGetSubstantiatedTypeMapping()

  if (errors.length) return <UnexpectedError />
  if (loading || !status) return <Spinner />

  return (<DefaultPage>
    <OutcomesView mappings={mappings} options={options} /> 
  </DefaultPage>)
}
